import { useBitrix } from '@context/useBitrixUser/useBitrix';
import { companyProfileService } from '@services/requests/companyProfileService';
import { RepresentativeData } from '@services/requests/companyProfileService/types/representativesData';
import React, { useEffect, useState } from 'react';

import { RepresentativesListModule } from '../../CompanyProfileModules/RepresentativesListModule';
import { RepresentativesTabSkeleton } from './RepresentativesTabSkeleton';
import { RepresentativesTabStyledContainer } from './StyledComponents';

function RepresentativesTab() {
  const [representativesData, setRepresentativesData] = useState<RepresentativeData | null>(null);
  const [isDataLoading, setIsDataLoading] = useState<boolean>(true);
  const [errors, setErrors] = useState<string[]>([]);

  const { useBitrixUser } = useBitrix();
  const [{ bitrixUser, isUserLoading }] = useBitrixUser().useState();

  useEffect(() => {
    if (!bitrixUser && !isUserLoading) {
      setIsDataLoading(false);
    }
    if (!bitrixUser || isUserLoading) {
      return;
    }
    const fetchData = async () => {
      const result = await companyProfileService().LoadRepresentativesData(bitrixUser.id);
      if ('errors' in result) {
        setIsDataLoading(false);
        setErrors(result.errors);
        return;
      }

      setIsDataLoading(false);
      setRepresentativesData(result);
    };
    fetchData();
  }, [bitrixUser, isUserLoading]);

  if (errors.length > 0) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {errors.map((error, index) => (
          <div key={'error-' + index}>
            <span className="company-status error">{error}</span>
          </div>
        ))}
      </div>
    );
  }

  if (isDataLoading) {
    return <RepresentativesTabSkeleton />;
  }

  if (!representativesData) {
    return null;
  }

  return (
    <RepresentativesTabStyledContainer>
      <RepresentativesListModule representativeData={representativesData} />
    </RepresentativesTabStyledContainer>
  );
}

export { RepresentativesTab };
